/** @format */

import React from 'react'

import {PluginKind} from '@src/types/Plugin'

type AddedByActionsTextProps = {
  addedBy: Set<PluginKind>
  className?: string
}

export function AddedByActionsText(props: AddedByActionsTextProps) {
  const {addedBy, className} = props
  switch (addedBy.size) {
    case 0:
      return null
    case 1: {
      const [action] = [...addedBy]
      return (
        <p className={className}>
          This validation is required by the {action} action.
        </p>
      )
    }
    default:
      return (
        <p className={className}>
          This validation is required by the {[...addedBy].join(', ')} actions.
        </p>
      )
  }
}
